export default "__VITE_ASSET__DfIOk9De__"